import { useEffect, useSyncExternalStore } from 'react';

/**
 * Registre de l'UNITÉ de la page courante (CHF / kCHF) — même patron que
 * `pageExports` : la section déclare son unité et de quoi la changer, la
 * BANDE DE PAGE l'affiche avec l'exercice et l'export (décision 2026-09-17).
 *
 * Motif : les commandes d'une page tenaient sur deux lignes, l'unité sur la
 * ligne des onglets et le reste au-dessus. Une seule ligne les réunit, et une
 * section sans unité n'affiche rien plutôt qu'un contrôle inerte.
 *
 * Forme : { value: 'chf' | 'kchf', onChange: (v) => void }
 */
let current = null;
const subs = new Set();

function notify() { subs.forEach((f) => f()); }

export function setPageUnit(unit) {
  current = unit || null;
  notify();
}

function subscribe(f) { subs.add(f); return () => subs.delete(f); }
function getSnapshot() { return current; }

/** Côté bande de page : l'unité déclarée, ou `null`. */
export function usePageUnit() {
  return useSyncExternalStore(subscribe, getSnapshot);
}

/** Côté section : déclare son unité tant qu'elle est montée. Une sous-page
    EMBARQUÉE passe `enabled = false` — c'est le hub qui déclare. */
export function useRegisterPageUnit(unit, enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;
    setPageUnit(unit);
    return () => setPageUnit(null);
  }, [unit, enabled]);
}
